export const COMPARE_STATUS_VALUE = {
  LESS: 'less',
  MORE: 'more',
  EQUAL: 'equal',
}

export const COMPARE_STATUS_NAME = {
  [COMPARE_STATUS_VALUE.LESS]: 'Less than',
  [COMPARE_STATUS_VALUE.MORE]: 'More than',
  [COMPARE_STATUS_VALUE.EQUAL]: 'Equal to',
}

export const COMPARE_STATUS_OPTIONS = [
  {
    value: COMPARE_STATUS_VALUE.LESS,
    label: COMPARE_STATUS_NAME[COMPARE_STATUS_VALUE.LESS],
  },
  {
    value: COMPARE_STATUS_VALUE.MORE,
    label: COMPARE_STATUS_NAME[COMPARE_STATUS_VALUE.MORE],
  },
  {
    value: COMPARE_STATUS_VALUE.EQUAL,
    label: COMPARE_STATUS_NAME[COMPARE_STATUS_VALUE.EQUAL],
  },
]

export const ORDER_TYPE_VALUE = {
  KIOSK: 'kiosk',
}

export const COVA_ORDER_STATUS_VALUE = {
  PENDING: 'pending',
  ON_HOLD: 'on-hold',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  FAILED: 'failed',
  REFUNDED: 'refunded',
  TRASH: 'trash',
  POS: 'pos',
}

export const COVA_ORDER_STATUS_NAME = {
  [COVA_ORDER_STATUS_VALUE.PENDING]: 'Pending',
  [COVA_ORDER_STATUS_VALUE.ON_HOLD]: 'On Hold',
  [COVA_ORDER_STATUS_VALUE.PROCESSING]: 'Processing',
  [COVA_ORDER_STATUS_VALUE.COMPLETED]: 'Completed',
  [COVA_ORDER_STATUS_VALUE.CANCELLED]: 'Cancelled',
  [COVA_ORDER_STATUS_VALUE.FAILED]: 'Failed',
  [COVA_ORDER_STATUS_VALUE.REFUNDED]: 'Refunded',
  [COVA_ORDER_STATUS_VALUE.TRASH]: 'Trash',
  [COVA_ORDER_STATUS_VALUE.POS]: 'POS orders',
}

export const COVA_ORDER_STATUS_TABS = [
  {
    value: 'all',
    label: 'Online orders',
  },
  {
    value: COVA_ORDER_STATUS_VALUE.PENDING,
    label: COVA_ORDER_STATUS_NAME[COVA_ORDER_STATUS_VALUE.PENDING],
  },
  {
    value: COVA_ORDER_STATUS_VALUE.ON_HOLD,
    label: COVA_ORDER_STATUS_NAME[COVA_ORDER_STATUS_VALUE.ON_HOLD],
  },
  {
    value: COVA_ORDER_STATUS_VALUE.PROCESSING,
    label: COVA_ORDER_STATUS_NAME[COVA_ORDER_STATUS_VALUE.PROCESSING],
  },
  {
    value: COVA_ORDER_STATUS_VALUE.COMPLETED,
    label: COVA_ORDER_STATUS_NAME[COVA_ORDER_STATUS_VALUE.COMPLETED],
  },
  {
    value: COVA_ORDER_STATUS_VALUE.CANCELLED,
    label: COVA_ORDER_STATUS_NAME[COVA_ORDER_STATUS_VALUE.CANCELLED],
  },
  {
    value: COVA_ORDER_STATUS_VALUE.FAILED,
    label: COVA_ORDER_STATUS_NAME[COVA_ORDER_STATUS_VALUE.FAILED],
  },
  {
    value: COVA_ORDER_STATUS_VALUE.REFUNDED,
    label: COVA_ORDER_STATUS_NAME[COVA_ORDER_STATUS_VALUE.REFUNDED],
  },
  {
    value: COVA_ORDER_STATUS_VALUE.TRASH,
    label: COVA_ORDER_STATUS_NAME[COVA_ORDER_STATUS_VALUE.TRASH],
  },
  {
    value: COVA_ORDER_STATUS_VALUE.POS,
    label: COVA_ORDER_STATUS_NAME[COVA_ORDER_STATUS_VALUE.POS],
  },
]

export const DEFAULT_COLUMN_COVA_OPTIONS = {
  _checkbox: true,
  id: true,
  customer: true,
  order_status: true,
  total: true,
  items: true,
  payment_status: true,
  fulfillment_type: true,
  fulfillment_status: true,
  order_time: true,
  delivery_fee: false,
  tips: false,
  driver: false,
  deliver_to: false,
  delivery_window: false,
  location: true,
}

export const DEFAULT_COLUMN_POS_COVA_OPTIONS = {
  id: true,
  customer: true,
  location: true,
  tendered: true,
  orderStatus: true,
  total: true,
  paymentStatus: true,
  createdTime: true,
}

export const COVA_POS_ORDER_STATUS = [
  { label: 'Confirmed', value: 'Confirmed' },
  { label: 'Completed', value: 'Completed' },
  { label: 'Cancelled', value: 'Cancelled' },
]

export const COVA_PAYMENT_STATUS_TYPE = {
  PAY_IN_STORE: 'pay_in_store',
  PAY_ON_DELIVERY: 'paid_on_delivery',
  PENDING_COD: 'pending_cod',
  PENDING_PAID_ON_DELIVERY: 'pending_paid_on_delivery',
  E_TRANSFER: 'e_transfer',
  PENDING_E_TRANSFER: 'pending_e_transfer',
  PAID_IET: 'paid_iet',
  PENDING_IET: 'pending_iet',
  CREDIT_CARD: 'credit_card',
  PENDING_CREDIT_CARD: 'pending_credit_card',
  CHEQUE_RECEIVED: 'cheque_received',
  PENDING_CHEQUE: 'pending_cheque',
  FAILED: 'failed',
}

export const COVA_PAYMENT_STATUS_NAME = {
  [COVA_PAYMENT_STATUS_TYPE.E_TRANSFER]: 'Paid (EMT)',
  [COVA_PAYMENT_STATUS_TYPE.PENDING_E_TRANSFER]: 'Unpaid (EMT)',
  [COVA_PAYMENT_STATUS_TYPE.CREDIT_CARD]: 'Paid (CC)',
  [COVA_PAYMENT_STATUS_TYPE.PENDING_CREDIT_CARD]: 'Unpaid (CC)',
  [COVA_PAYMENT_STATUS_TYPE.PAY_IN_STORE]: 'Paid (In-store)',
  [COVA_PAYMENT_STATUS_TYPE.PAY_ON_DELIVERY]: 'Paid (On delivery)',
  [COVA_PAYMENT_STATUS_TYPE.PENDING_COD]: 'Unpaid (In-store)',
  [COVA_PAYMENT_STATUS_TYPE.PENDING_PAID_ON_DELIVERY]: 'Unpaid (On delivery)',
  [COVA_PAYMENT_STATUS_TYPE.CHEQUE_RECEIVED]: 'Paid (Cheque)',
  [COVA_PAYMENT_STATUS_TYPE.PENDING_CHEQUE]: 'Unpaid (Cheque)',
  [COVA_PAYMENT_STATUS_TYPE.FAILED]: 'Failed Payment',
  [COVA_PAYMENT_STATUS_TYPE.PENDING_IET]: 'Unpaid (IET)',
  [COVA_PAYMENT_STATUS_TYPE.PAID_IET]: 'Paid (IET)',
}

export const COVA_PAYMENT_STATUS_OPTIONS = Object.values(
  COVA_PAYMENT_STATUS_TYPE,
).map((item) => ({
  value: item,
  label: COVA_PAYMENT_STATUS_NAME[item],
}))

export const POS_PAYMENT_STATUS_TYPE = {
  PAY_IN_STORE: 'pay_in_store',
  E_TRANSFER: 'e_transfer',
  CREDIT_CARD: 'credit_card',
  PENDING_PAYMENT: 'pending_payment',
  PAID: 'paid',
  FAILED: 'failed',
}

export const POS_PAYMENT_STATUS_NAME = {
  [POS_PAYMENT_STATUS_TYPE.PAY_IN_STORE]: 'Paid (In-store)',
  [POS_PAYMENT_STATUS_TYPE.E_TRANSFER]: 'Paid (EMT)',
  [POS_PAYMENT_STATUS_TYPE.CREDIT_CARD]: 'Paid (CC)',
  [POS_PAYMENT_STATUS_TYPE.PENDING_PAYMENT]: 'Unpaid',
  [POS_PAYMENT_STATUS_TYPE.PAID]: 'Paid',
  [POS_PAYMENT_STATUS_TYPE.FAILED]: 'Failed',
}

export const POS_PAYMENT_STATUS_OPTIONS = Object.values(
  POS_PAYMENT_STATUS_TYPE,
).map((item) => ({
  value: item,
  label: POS_PAYMENT_STATUS_NAME[item],
}))

export const COVA_PAYMENT_STATUS_ICON = {
  [COVA_PAYMENT_STATUS_TYPE.PAY_IN_STORE]: {
    icon: 'checkbox-circle',
    title: 'Paid (In-store)',
    color: '#0D8050',
    typeIcon: 'money-dollar-circle',
    typeTitle: 'Pay in-store',
  },
  [COVA_PAYMENT_STATUS_TYPE.PAY_ON_DELIVERY]: {
    icon: 'checkbox-circle',
    title: 'Paid (On delivery)',
    color: '#0D8050',
    typeIcon: 'money-dollar-circle',
    typeTitle: 'Pay on delivery',
  },
  [COVA_PAYMENT_STATUS_TYPE.PENDING_COD]: {
    icon: 'alert',
    title: 'Unpaid (In-store)',
    color: '#D6A647',
    typeIcon: 'money-dollar-circle',
    typeTitle: 'Pay in-store',
  },
  [COVA_PAYMENT_STATUS_TYPE.PENDING_PAID_ON_DELIVERY]: {
    icon: 'alert',
    title: 'Unpaid (On delivery)',
    color: '#D6A647',
    typeIcon: 'money-dollar-circle',
    typeTitle: 'Pay on delivery',
  },
  [COVA_PAYMENT_STATUS_TYPE.E_TRANSFER]: {
    icon: 'checkbox-circle',
    title: 'Paid (EMT)',
    color: '#0D8050',
    typeIcon: 'mail-send',
    typeTitle: 'Email transfer',
  },
  [COVA_PAYMENT_STATUS_TYPE.PENDING_E_TRANSFER]: {
    icon: 'alert',
    title: 'Unpaid (EMT)',
    color: '#D6A647',
    typeIcon: 'mail-send',
    typeTitle: 'Email transfer',
  },
  [COVA_PAYMENT_STATUS_TYPE.CREDIT_CARD]: {
    icon: 'checkbox-circle',
    title: 'Paid (CC)',
    color: '#0D8050',
    typeIcon: 'bank-card',
    typeTitle: 'Credit card',
  },
  [COVA_PAYMENT_STATUS_TYPE.PENDING_CREDIT_CARD]: {
    icon: 'alert',
    title: 'Unpaid (CC)',
    color: '#D6A647',
    typeIcon: 'bank-card',
    typeTitle: 'Credit card',
  },
  [COVA_PAYMENT_STATUS_TYPE.CHEQUE_RECEIVED]: {
    icon: 'checkbox-circle',
    title: 'Paid (Cheque)',
    color: '#0D8050',
    typeIcon: 'pen-nib',
    typeTitle: 'Cheque',
  },
  [COVA_PAYMENT_STATUS_TYPE.PENDING_CHEQUE]: {
    icon: 'alert',
    title: 'Unpaid (Cheque)',
    color: '#D6A647',
    typeIcon: 'pen-nib',
    typeTitle: 'Cheque',
  },
  [COVA_PAYMENT_STATUS_TYPE.FAILED]: {
    icon: 'alert',
    title: 'Failed Payment',
    color: '#F24822',
    typeIcon: '',
    typeTitle: '-',
  },
  [COVA_PAYMENT_STATUS_TYPE.PENDING_IET]: {
    icon: 'alert',
    title: 'Unpaid (IET)',
    color: '#D6A647',
    typeIcon: 'remote-control',
    typeTitle: 'Interac',
  },
  [COVA_PAYMENT_STATUS_TYPE.PAID_IET]: {
    icon: 'checkbox-circle',
    title: 'Paid (IET)',
    color: '#0D8050',
    typeIcon: 'remote-control',
    typeTitle: 'Interac',
  },
  [POS_PAYMENT_STATUS_TYPE.PAY_IN_STORE]: {
    icon: 'checkbox-circle',
    title: 'Paid (In-store)',
    color: '#0D8050',
    typeIcon: 'money-dollar-circle',
    typeTitle: 'Pay in-store',
  },
  [POS_PAYMENT_STATUS_TYPE.E_TRANSFER]: {
    icon: 'checkbox-circle',
    title: 'Paid (EMT)',
    color: '#0D8050',
    typeIcon: 'mail-send',
    typeTitle: 'Email transfer',
  },
  [POS_PAYMENT_STATUS_TYPE.CREDIT_CARD]: {
    icon: 'checkbox-circle',
    title: 'Paid (CC)',
    color: '#0D8050',
    typeIcon: 'bank-card',
    typeTitle: 'Credit card',
  },
  [POS_PAYMENT_STATUS_TYPE.PAID]: {
    icon: 'checkbox-circle',
    title: 'Paid',
    color: '#0D8050',
    typeIcon: '',
    typeTitle: '-',
  },
  [POS_PAYMENT_STATUS_TYPE.PENDING_PAYMENT]: {
    icon: 'alert',
    title: 'Unpaid',
    color: '#D6A647',
    typeIcon: '',
    typeTitle: '-',
  },
}

export const COVA_CUSTOMER_SHIPPING_TYPE = {
  FLAT_RATE: 'flat_rate',
  FREE_SHIPPING: 'free_shipping',
  LOCAL_PICKUP: 'local_pickup',
  CANADA_POST: 'canada_post_shipping_by_nosites_left',
  CANADA_POST_XPRESS: 'canada_post',
  ONFLEET_LOCAL_DELIVERY: 'bsof_local_shipping',
  ONFLEET_DELIVERY: 'onfleet_delivery',
  CURBSIDE_PICKUP: 'curbside_pickup',
  CANTEC_DELIVERY: 'cantec_delivery',
  CANTEC_LOCAL_PICKUP: 'cantec_local_pickup',
  CANFLEET_DELIVERY: 'breadstack_canfleet_local_shipping',
  CANFLEET_LOCAL_SHIPPING: 'canfleet_local_shipping',
  DRIVE_THRU: 'drive_through_pickup',
  OTHERS: 'others',
  TWO_POINT_DELIVERY: 'bs_tpd_local_shipping',
  HOMERUN_DELIVERY: 'bs_homerun_local_shipping',
}

export const COVA_CUSTOMER_SHIPPING_ICON = {
  [COVA_CUSTOMER_SHIPPING_TYPE.FLAT_RATE]: {
    icon: 'ic_shipping_regular',
    title: 'Mail order',
  },
  [COVA_CUSTOMER_SHIPPING_TYPE.FREE_SHIPPING]: {
    icon: 'ic_shipping_regular',
    title: 'Mail order',
  },
  [COVA_CUSTOMER_SHIPPING_TYPE.LOCAL_PICKUP]: {
    icon: 'ic_shipping_others',
    title: 'Others',
  },
  [COVA_CUSTOMER_SHIPPING_TYPE.CANADA_POST]: {
    icon: 'ic_shipping_regular',
    title: 'Mail order',
  },
  [COVA_CUSTOMER_SHIPPING_TYPE.CANADA_POST_XPRESS]: {
    icon: 'ic_shipping_regular',
    title: 'Mail order',
  },
  [COVA_CUSTOMER_SHIPPING_TYPE.ONFLEET_LOCAL_DELIVERY]: {
    icon: 'ic_onfleet',
    title: 'Onfleet',
  },
  [COVA_CUSTOMER_SHIPPING_TYPE.CANFLEET_LOCAL_SHIPPING]: {
    icon: 'ic_onfleet',
    title: 'Onfleet',
  },
  [COVA_CUSTOMER_SHIPPING_TYPE.ONFLEET_DELIVERY]: {
    icon: 'ic_onfleet',
    title: 'Onfleet',
  },
  [COVA_CUSTOMER_SHIPPING_TYPE.CURBSIDE_PICKUP]: {
    icon: 'ic_shipping_curbside',
    title: 'Curbside',
  },
  [COVA_CUSTOMER_SHIPPING_TYPE.CANTEC_DELIVERY]: {
    icon: 'ic_shipping_others',
    title: 'Others',
  },
  [COVA_CUSTOMER_SHIPPING_TYPE.CANFLEET_DELIVERY]: {
    icon: 'ic_shipping_canfleet',
    title: 'CanFleet',
  },
  [COVA_CUSTOMER_SHIPPING_TYPE.CANTEC_LOCAL_PICKUP]: {
    icon: 'ic_shipping_store',
    title: 'Store pickup',
  },
  [COVA_CUSTOMER_SHIPPING_TYPE.DRIVE_THRU]: {
    icon: 'ic_shipping_drive_thru',
    title: 'Drive thru',
  },
  [COVA_CUSTOMER_SHIPPING_TYPE.TWO_POINT_DELIVERY]: {
    icon: 'ic_two_point',
    title: '2Point',
  },
  [COVA_CUSTOMER_SHIPPING_TYPE.HOMERUN_DELIVERY]: {
    icon: 'ic_homerun',
    title: 'Homerun',
  },
}

export const FULFILLMENT_TYPE_VALUE = {
  PICKUP_IN_STORE: 'cantec_local_pickup',
  CURBSIDE_PICKUP: 'curbside_pickup',
  CANTEC_DELIVERY: 'cantec_delivery',
  BS_OF_SHIPPING: 'bsof_local_shipping',
  BS_HOMERUN_SHIPPING: 'bs_homerun_local_shipping',
  BS_TPD_SHIPPING: 'bs_tpd_local_shipping',
  BS_CANFLEET_SHIPPING: 'breadstack_canfleet_local_shipping',
  FLAT_RATE: 'flat_rate',
  FREE_SHIPPING: 'free_shipping',
  CANADA_POST: 'canada_post_shipping_by_nosites_left',
  CANADA_POST_XPRESS: 'canada_post',
  LOCAL_PICKUP: 'local_pickup',
  DRIVE_THRU: 'drive_through_pickup',
}

export const FULFILLMENT_TYPE_ICON = {
  [FULFILLMENT_TYPE_VALUE.FLAT_RATE]: {
    icon: 'ic_shipping_regular',
    title: 'Mail order',
  },
  [FULFILLMENT_TYPE_VALUE.FREE_SHIPPING]: {
    icon: 'ic_shipping_regular',
    title: 'Mail order',
  },
  [FULFILLMENT_TYPE_VALUE.CANADA_POST]: {
    icon: 'ic_shipping_regular',
    title: 'Mail order',
  },
  [FULFILLMENT_TYPE_VALUE.CANADA_POST_XPRESS]: {
    icon: 'ic_shipping_regular',
    title: 'Mail order',
  },
  [FULFILLMENT_TYPE_VALUE.LOCAL_PICKUP]: {
    icon: 'ic_shipping_others',
    title: 'Others',
  },
  [FULFILLMENT_TYPE_VALUE.BS_OF_SHIPPING]: {
    icon: 'ic_onfleet',
    title: 'Onfleet',
  },
  [FULFILLMENT_TYPE_VALUE.CURBSIDE_PICKUP]: {
    icon: 'ic_shipping_curbside',
    title: 'Curbside',
  },
  [FULFILLMENT_TYPE_VALUE.CANTEC_DELIVERY]: {
    icon: 'ic_shipping_others',
    title: 'Others',
  },
  [FULFILLMENT_TYPE_VALUE.BS_CANFLEET_SHIPPING]: {
    icon: 'ic_shipping_canfleet',
    title: 'CanFleet',
  },
  [FULFILLMENT_TYPE_VALUE.PICKUP_IN_STORE]: {
    icon: 'ic_shipping_store',
    title: 'Store pickup',
  },
  [FULFILLMENT_TYPE_VALUE.DRIVE_THRU]: {
    icon: 'ic_shipping_drive_thru',
    title: 'Drive thru',
  },
  [FULFILLMENT_TYPE_VALUE.BS_HOMERUN_SHIPPING]: {
    icon: 'ic_homerun',
    title: 'Homerun',
  },
  [FULFILLMENT_TYPE_VALUE.BS_TPD_SHIPPING]: {
    icon: 'ic_two_point',
    title: '2Point',
  },
}

export const COVA_FULFILLMENT_STATUS = {
  PENDING_PICKING: 'pending_picking',
  PENDING_PICKUP: 'pending_pickup',
  IN_TRANSIT: 'in_transit',
  COMPLETED: 'completed',
  EMPTY: 'empty',
  CANCEL: 'cancelled',
  PICKING_AND_WAYBILL: 'picking_&_waybill',
  PENDING_DELIVERY: 'pending_delivery',
  TRACKING: 'tracking',
}

export const COVA_FULFILLMENT_STATUS_NAME = {
  [COVA_FULFILLMENT_STATUS.PENDING_PICKING]: {
    title: 'Pending picking',
    color: '#3828A4',
  },
  [COVA_FULFILLMENT_STATUS.PENDING_PICKUP]: {
    title: 'Pending pickup',
    color: '#B849A0',
  },
  [COVA_FULFILLMENT_STATUS.IN_TRANSIT]: {
    title: 'In transit',
    color: '#D6A647',
  },
  [COVA_FULFILLMENT_STATUS.COMPLETED]: {
    title: 'Delivered',
    color: '#0D8050',
  },
  [COVA_FULFILLMENT_STATUS.EMPTY]: {
    title: 'Awaiting',
    color: '#F24822',
    bgColor: 'rgba(242, 72, 34, 0.1)',
  },
  [COVA_FULFILLMENT_STATUS.CANCEL]: {
    title: 'Cancelled',
    color: '#33363D66',
    bgColor: 'rgba(0, 0, 0, 0.08)',
  },
  [COVA_FULFILLMENT_STATUS.PICKING_AND_WAYBILL]: {
    title: 'Pending waybill',
    color: '#3828A4',
  },
  [COVA_FULFILLMENT_STATUS.PENDING_DELIVERY]: {
    title: 'Pending delivery',
    color: '#2E7FB2',
  },
  [COVA_FULFILLMENT_STATUS.TRACKING]: {
    title: 'Delivered',
    color: '#0D8050',
  },
}

export const COVA_FULFILLMENT_STATUS_OPTIONS = [
  {
    value: COVA_FULFILLMENT_STATUS.PENDING_PICKING,
    label:
      COVA_FULFILLMENT_STATUS_NAME[COVA_FULFILLMENT_STATUS.PENDING_PICKING]
        .title,
  },
  {
    value: COVA_FULFILLMENT_STATUS.PENDING_PICKUP,
    label:
      COVA_FULFILLMENT_STATUS_NAME[COVA_FULFILLMENT_STATUS.PENDING_PICKUP]
        .title,
  },
  {
    value: COVA_FULFILLMENT_STATUS.IN_TRANSIT,
    label:
      COVA_FULFILLMENT_STATUS_NAME[COVA_FULFILLMENT_STATUS.IN_TRANSIT].title,
  },
  {
    value: COVA_FULFILLMENT_STATUS.COMPLETED,
    label:
      COVA_FULFILLMENT_STATUS_NAME[COVA_FULFILLMENT_STATUS.COMPLETED].title,
  },
  {
    value: COVA_FULFILLMENT_STATUS.EMPTY,
    label: COVA_FULFILLMENT_STATUS_NAME[COVA_FULFILLMENT_STATUS.EMPTY].title,
  },
  {
    value: COVA_FULFILLMENT_STATUS.CANCEL,
    label: COVA_FULFILLMENT_STATUS_NAME[COVA_FULFILLMENT_STATUS.CANCEL].title,
  },
  {
    value: COVA_FULFILLMENT_STATUS.PICKING_AND_WAYBILL,
    label:
      COVA_FULFILLMENT_STATUS_NAME[COVA_FULFILLMENT_STATUS.PICKING_AND_WAYBILL]
        .title,
  },
  {
    value: COVA_FULFILLMENT_STATUS.PENDING_DELIVERY,
    label:
      COVA_FULFILLMENT_STATUS_NAME[COVA_FULFILLMENT_STATUS.PENDING_DELIVERY]
        .title,
  },
  // {
  //   value: COVA_FULFILLMENT_STATUS.TRACKING,
  //   label: COVA_FULFILLMENT_STATUS_NAME[COVA_FULFILLMENT_STATUS.TRACKING].title,
  // },
]

export const LIGHTSPEED_ORDER_STATUS_VALUE = {
  SAVED: 'SAVED',
  CLOSED: 'CLOSED',
  VOIDED: 'VOIDED',
  ONACCOUNT: 'ONACCOUNT',
  LAYBY: 'LAYBY',
  ONACCOUNT_CLOSED: 'ONACCOUNT_CLOSED',
  LAYBY_CLOSED: 'LAYBY_CLOSED',
  AWAITING_DISPATCH: 'AWAITING_DISPATCH',
  AWAITING_PICKUP: 'AWAITING_PICKUP',
  DISPATCHED_CLOSED: 'DISPATCHED_CLOSED',
  PICKED_UP_CLOSED: 'PICKED_UP_CLOSED',
  SERVICE: 'SERVICE',
  SERVICE_CLOSED: 'SERVICE_CLOSED',
}

export const LIGHTSPEED_ORDER_STATUS = {
  [LIGHTSPEED_ORDER_STATUS_VALUE.SAVED]: 'Saved',
  [LIGHTSPEED_ORDER_STATUS_VALUE.CLOSED]: 'Closed',
  [LIGHTSPEED_ORDER_STATUS_VALUE.VOIDED]: 'Voided',
  [LIGHTSPEED_ORDER_STATUS_VALUE.ONACCOUNT]: 'On account',
  [LIGHTSPEED_ORDER_STATUS_VALUE.LAYBY]: 'Layby',
  [LIGHTSPEED_ORDER_STATUS_VALUE.ONACCOUNT_CLOSED]: 'On account closed',
  [LIGHTSPEED_ORDER_STATUS_VALUE.LAYBY_CLOSED]: 'Layby closed',
  [LIGHTSPEED_ORDER_STATUS_VALUE.AWAITING_DISPATCH]: 'Awaiting dispatch',
  [LIGHTSPEED_ORDER_STATUS_VALUE.AWAITING_PICKUP]: 'Awaiting pickup',
  [LIGHTSPEED_ORDER_STATUS_VALUE.DISPATCHED_CLOSED]: 'Dispatched closed',
  [LIGHTSPEED_ORDER_STATUS_VALUE.PICKED_UP_CLOSED]: 'Picked up closed',
  [LIGHTSPEED_ORDER_STATUS_VALUE.SERVICE]: 'Service',
  [LIGHTSPEED_ORDER_STATUS_VALUE.SERVICE_CLOSED]: 'Service closed',
}
